import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=c71ba27c&scoped=true&"
import script from "./ListHeader.vue?vue&type=script&lang=js&"
export * from "./ListHeader.vue?vue&type=script&lang=js&"
import style0 from "./ListHeader.vue?vue&type=style&index=0&id=c71ba27c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71ba27c",
  null
  
)

export default component.exports